import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToPagePosition = ({ scrollToTop = true }: { scrollToTop?: boolean }) => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) {
            const element = document.getElementById(hash.slice(1));
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        } else {
            if (scrollToTop) {
                window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
            }
        }
    }, [pathname, hash, scrollToTop]);

    return null;
};
